var React = require('react');

function ExpandInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 3C9.4841 3 9.06667 3.41745 9.06667 3.93333V9.06667H3.93333C3.41743 9.06667 3 9.48411 3 10C3 10.5159 3.41745 10.9333 3.93333 10.9333H9.06667V16.0667C9.06667 16.5826 9.48411 17 10 17C10.5159 17 10.9333 16.5826 10.9333 16.0667V10.9333H16.0667C16.5826 10.9333 17 10.5159 17 10C17 9.48411 16.5826 9.06667 16.0667 9.06667H10.9333V3.93333C10.9333 3.41743 10.5159 3 10 3Z","fill":"#262626"}));
}

ExpandInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ExpandInline;

ExpandInline.default = ExpandInline;
